import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { isStructuredContent } from '@repo/supergraph/structuredContent/utils';
import { getAllChildrenStrings } from '../StructuredContentRenderer/utils';

type ContentHeading = {
  id: string;
  header: string;
};

export const getChildrenHeadings = (parentDocument: StructuredContentDocument) => {
  const contentHeadings: ContentHeading[] = [];

  const findContentHeadings = (doc: StructuredContentDocument) => {
    if (['ContentHeading'].includes(doc.type) && doc.props.level === 2) {
      const childrenString = getAllChildrenStrings(doc);
      contentHeadings.push({
        id: getHeadingId(childrenString),
        header: childrenString,
      });
    }

    const children = doc.props.children;

    if (Array.isArray(children)) {
      children.forEach(child => {
        if (isStructuredContent(child)) {
          findContentHeadings(child);
        }
      });
    }

    return contentHeadings;
  };

  return findContentHeadings(parentDocument);
};

export const getHeadingId = (childrenString: string) => {
  return childrenString
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '')
    .toLowerCase();
};

export const COMPONENT_ID_DESKTOP = 'table-of-contents-desktop';
export const COMPONENT_ID_MOBILE = 'table-of-contents-mobile';
